<template>
  <div
    v-if="canGotoNextPage"
    class="paginator-button-wrapper paginator-button-wrapper--next"
  >
    <a
      class="styled-button"
      :class="{ 'styled-button--disabled': isFetching }"
      :disabled="isFetching"
      :href="nextUrl"
      @click.prevent="next"
    >
      <dpc-icon class="styled-button__icon" icon="plus" decorative />
      <span class="styled-button__text">
        <slot />
      </span>
    </a>
  </div>
</template>

<script setup>
import { inject, watch, ref } from 'vue';
import { useBrowserLocation } from '@vueuse/core';

const isFetching = inject('api/isFetching');
const next = inject('api/paginator/next');
const canGotoNextPage = inject('api/paginator/canGotoNextPage');

const highestPage = inject('api/paginator/highestPage');
const location = useBrowserLocation();
const nextUrl = ref(location.value.href);

watch(
  highestPage,
  highestPage => {
    if (!highestPage) return;
    const url = new URL(nextUrl.value);
    url.searchParams.set('page', highestPage + 1);
    nextUrl.value = url.toString();
  },
  { immediate: true }
);
</script>
